// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"HY-z","subtitle":"IY-z","wrapper":"JY-z","leftArrow":"KY-z","rightArrow":"LY-z"};